import { render, staticRenderFns } from "./DocumentLocked.vue?vue&type=template&id=05141c50&"
import script from "./DocumentLocked.vue?vue&type=script&lang=js&"
export * from "./DocumentLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports